import TrashcanIcon from "public/images/pricing/business/businessAutomateControl.svg";
import postIcon from "public/images/pricing/business/businessDeletePosts.svg";
import socialMediaSitesIcon from "public/images/pricing/business/businessMoreSocialMedia.svg";
import oldSocialMediaIcon from "public/images/pricing/business/businessOldSocialMedia.svg";
import newsHeadlineIcon from "public/images/pricing/business/businessAvoidHeadlines.svg";
import protectInfoIcon from "public/images/pricing/business/businessProtectInfo.svg";
import umbrellaIcon from "public/images/pricing/business/businessTakeProactive.svg";
import justiceWeighIcon from "public/images/pricing/business/businessPreventLawsuits.svg";
import Image from "next/image";

const Table = () => {
  return (
    <div className="flex w-full items-end justify-center">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="mt-5 ml-5 flex h-[336px] flex-col">
          <div className="mt-0 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling posts"
                width={39}
                height={30}
                src={postIcon}
                className="flex w-[39px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Delete your post, comments, likes, DMs and more! Across all major platforms
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling major social media sites"
                width={29}
                height={30}
                src={socialMediaSitesIcon}
                className="flex w-[29px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              35+ Major social media & direct messaging platforms supported
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling dangers of old social media"
                width={29}
                height={30}
                src={oldSocialMediaIcon}
                className="flex w-[29px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Old social media post are an attack vector for bad actors to target and gather
              information leaks
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling dangers of old posts"
                width={29}
                height={30}
                src={newsHeadlineIcon}
                className="flex w-[29px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Avoid unwanted headlines due to posting mishaps
            </span>
          </div>
        </div>

        <div className="mt-5 ml-5 flex h-[336px] flex-col">
          <div className="mt-0 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling of a trashcan"
                width={22}
                height={30}
                src={TrashcanIcon}
                className="flex w-[22px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Automate control over your organizations social media
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling of a lightbulb"
                width={30}
                height={30}
                src={protectInfoIcon}
                className="flex w-[30px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Protect information leaks by using automatic keyword deletion
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling of an umbrella"
                width={35}
                height={30}
                src={umbrellaIcon}
                className="flex w-[35px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Take proactive steps stop online harrassment, bullying and brigading of your or & team
              members
            </span>
          </div>
          <div className="mt-7 flex h-[60px] flex-row items-center justify-start">
            <div className="flex h-[60px] w-[60px] items-center justify-center rounded-xl bg-brand-slate shadow-black shadow-md">
              <Image
                alt="Icon resembling of a justice weigh"
                width={34}
                height={30}
                src={justiceWeighIcon}
                className="flex w-[34px] items-center"
              />
            </div>
            <span className="ml-5 w-3/4 sm:w-[411px]">
              Prevent copyright lawsuits using using automatic deletion
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Table;
